<!-- @format -->

<div
	class="custom-switch"
	[ngClass]="enabled ? 'active' : 'inactive'"
	(click)="disabled ? null : toggleSwitch()">
	<div class="custom-switch__thumb"></div>
</div>
